import { ILoginRequest } from "models/Login/login.model";

export const defaultFormValues: ILoginRequest = {
  phoneNumber: "",
  password: "",
  adSoyad: "",
  corporateIndividual: "",
};

export const defaultFormValuesCorp: ILoginRequest = {
  userId: "",
  merchantNumber: "",
  password: "",
  adSoyad: "",
  corporateIndividual: "",
};
